import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "entries", "pagination" ]
  static values = {
    frame: { type: Boolean, default: false }
  }

  connect() {
    if (!this.frameValue) return

    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.initFetchData()
            this.observer.disconnect() // Stop observing after first fetch
          }
        })
      })

      this.observer.observe(this.element)
    } else {
      this.initFetchData()
    }
  }

  initFetchData() {
    let a = this.paginationTarget.querySelector("a[rel='next']")
    if (a == null) { return }
    a.click()
  }

  initialize() {
    this.loading = false
  }

  scroll() {
    let a = this.paginationTarget.querySelector("a[rel='next']")
    if (a == null) { return }

    let body = document.body,
      html = document.documentElement
    
    let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    if (window.pageYOffset >= (height - window.innerHeight - 200)) {
      a.click()
    }
  }

  appendItems(event) {
    let [data, status, xhr] = event.detail
    this.entriesTarget.insertAdjacentHTML('beforeend', data.entries)
    this.paginationTarget.innerHTML = data.pagination
  }

  completed(event) {
    this.loading = false
  }
}
